import React, { useState, useEffect } from 'react'
import SetEmployeeInfo from './SetEmployeeInfo'
import CheckEmployeeInfo from './CheckEmployeeInfo';
import CompleteModal from './CompleteModal';
import { useTutorialContext } from '../TutorialProvider';
import { removeTutorialThisUser } from '../../../utils/Tutorial';
export default function Step3({ values, tutorialStep3 }) {

  const { run, stepIndex, tourCompleted, type, employeeId } = tutorialStep3
  const [loader, setLoader] = useState(false)
  const [onOpenModal, setOnOpenModal] = useState(tourCompleted)
  const [isExpand, setIsExpand] = useState(false)
  const { setTutorialStep3 } = useTutorialContext()

  useEffect(() => {
    setTimeout(() => setLoader(true), 1400)
    if (type == 'checkInfo' && stepIndex == 4 && !isExpand) {
      const wrapper = document.querySelector('a[name="BankInfomation"] + section .u-txt-addinfo')
      if (wrapper) wrapper.click()
      setIsExpand(true)
    }
  }, [])

  const onCompleteTutorial = () => {
    setOnOpenModal(true)
  }
  const setOnCloseModal = () => {
    setOnOpenModal(false)
    removeTutorialThisUser()
  }

  return (
    <div>
      {loader &&
        <React.Fragment>
          {tourCompleted && <CompleteModal setOnCloseModal={setOnCloseModal} onOpenModal={onOpenModal} />}
          {(type == 'setInfo' && !tourCompleted) && <SetEmployeeInfo cookie={tutorialStep3} setTutorialStep3={setTutorialStep3} />}
          {(type == 'checkInfo' && !tourCompleted) && <CheckEmployeeInfo cookie={tutorialStep3} onCompleteTutorial={onCompleteTutorial}
            values={values} setTutorialStep3={setTutorialStep3} isExpand={isExpand} setIsExpand={setIsExpand} />
          }
        </React.Fragment>
      }
    </div>
  )
}
